"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preparePayloadForAuthorization = exports.prepareBillingAddressForAuth = exports.getUserData = exports.getPaymentData = exports.getInputFieldValues = exports.getBillingAddressData = exports.getBifurcatedName = exports.constructUserDetailsForPostValidate = exports.additionalDataSerializers = void 0;
var _constants = require("../../../constants/constants");
var _commonUtils = require("../../../utils/commonUtils");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Prepare payment data for payload from Adyen state
 *
 * @param data: Raw Adyen state data
 * @returns {Object}: Prepare object with payment data to be used in payload
 */
var getPaymentData = function getPaymentData(data) {
  switch (data.paymentMethod.type) {
    case 'scheme':
      return {
        paymentMethod: _constants.ADYEN_PAYMENT_METHOD_TYPES.scheme,
        payload: {
          cardNumber: data.paymentMethod.encryptedCardNumber,
          expirationMonth: data.paymentMethod.encryptedExpiryMonth,
          expirationYear: data.paymentMethod.encryptedExpiryYear,
          cardValidationNumber: data.paymentMethod.encryptedSecurityCode,
          encrypted: true,
          storePaymentMethod: data.storePaymentMethod,
          storedPaymentMethodId: data.paymentMethod.storedPaymentMethodId
        }
      };
    case 'ideal':
      return {
        paymentMethod: _constants.ADYEN_PAYMENT_METHOD_TYPES.ideal,
        payload: {
          issuerId: data.paymentMethod.issuer
        }
      };
    case 'directEbanking':
      return {
        paymentMethod: _constants.ADYEN_PAYMENT_METHOD_TYPES.directEbanking,
        payload: {
          countryCode: data.countryCode
        }
      };
    case 'giropay':
      return {
        paymentMethod: _constants.ADYEN_PAYMENT_METHOD_TYPES.giropay
      };
    case 'pix':
      return {
        paymentMethod: _constants.ADYEN_PAYMENT_METHOD_TYPES.pix
      };
  }
};

/**
 * Function used to get values from Input fields
 *
 * @param referenceContainer: Container containing the reference of all fields
 * @param additionalData: The serialized data gathered post validation
 * @returns {Object}: Search the values in field reference, if not found try searching in the additionalData.
 *           Finally return an object containing all field values.
 */
exports.getPaymentData = getPaymentData;
var getInputFieldValues = function getInputFieldValues(referenceContainer, additionalData) {
  /**
   *
   * @param element: The reference of the element to search value from
   * @param index: The probable index where the input element might lie
   * @returns: The value after reading the DOM
   */
  var getValueFromInputFieldReference = function getValueFromInputFieldReference(element, index) {
    return element.nodeName === 'INPUT' ? element.value : element.getElementsByTagName('input')[index].value;
  };

  /**
   *
   * @param ref: The reference of the field
   * @param probableIndex: The probable index containing the input element
   * @param additionalDataValue: The additional value of the field (if provided post validation)
   * @returns: The field value
   */
  var getFieldValue = function getFieldValue(ref, probableIndex, additionalDataValue) {
    return ref ? getValueFromInputFieldReference(ref, probableIndex) : additionalDataValue;
  };

  /**
   * Get all the field values from field reference if present,
   * else search them from the additional Data.
   */
  var firstName = getFieldValue(referenceContainer['nameInputField'], 0, additionalData['purchaserFirstName']);
  var lastName = getFieldValue(referenceContainer['nameInputField'], 1, additionalData['purchaserLastName']);
  var emailAddress = (0, _commonUtils.trimEmail)(getFieldValue(referenceContainer['emailInputField'], 0, additionalData['purchaserEmail']));
  var phoneNumber = getFieldValue(referenceContainer['phoneInputField'], 0, additionalData['phone']);
  return {
    firstName: firstName,
    lastName: lastName,
    emailAddress: (0, _commonUtils.trimEmail)(emailAddress),
    phoneNumber: phoneNumber
  };
};
exports.getInputFieldValues = getInputFieldValues;
var getBifurcatedName = function getBifurcatedName(data) {
  // eslint-disable-next-line no-irregular-whitespace
  data = data.replace(/[\u00A0\u1680​\u180e\u2000-\u2009\u200a​\u200b​\u202f\u205f​\u3000]/g, ' ');
  var names = data && data.trim().split(' ');
  var firstName, lastName;
  if (names.length < 2) {
    firstName = names[0];
    //set lastName as Last name unknown as it's a recognised abbrevation
    lastName = 'LNU';
  } else {
    firstName = names.slice(0, -1).join(' ').trim();
    lastName = names[names.length - 1].trim();
  }
  return {
    firstName: firstName,
    lastName: lastName
  };
};

/**
 * Used to prepare the address data and input fields data
 *
 */
exports.getBifurcatedName = getBifurcatedName;
var getBillingAddressData = function getBillingAddressData(data, stateRef, referenceContainer) {
  var _stateRef$current;
  var inputFieldValues = getInputFieldValues(referenceContainer, {});
  var billingAddress = _objectSpread(_objectSpread({}, inputFieldValues), prepareBillingAddressForAuth(data, inputFieldValues, stateRef === null || stateRef === void 0 || (_stateRef$current = stateRef.current) === null || _stateRef$current === void 0 ? void 0 : _stateRef$current.getAdyenBillingAddress()));
  (0, _commonUtils.updateNAToUndefined)(billingAddress);
  return billingAddress;
};

/**
 * Prepares the Billing address payload for making a call to paymentPlus
 * for Authorization.
 *
 */
exports.getBillingAddressData = getBillingAddressData;
var prepareBillingAddressForAuth = function prepareBillingAddressForAuth(data, inputFieldValues, adyenBillingAddress) {
  var _data$billingAddress;
  var bifurcatedName = data.paymentMethod.holderName && getBifurcatedName(data.paymentMethod.holderName);
  if (data && !data.billingAddress && adyenBillingAddress !== null && adyenBillingAddress !== void 0 && adyenBillingAddress.billingAddress) {
    data.billingAddress = adyenBillingAddress === null || adyenBillingAddress === void 0 ? void 0 : adyenBillingAddress.billingAddress;
  }
  switch (data.paymentMethod.type) {
    case 'scheme':
      return data && data.billingAddress ? {
        addressType: 'BILLING',
        addressLine1: (_data$billingAddress = data.billingAddress) === null || _data$billingAddress === void 0 ? void 0 : _data$billingAddress.houseNumberOrName,
        addressLine2: data.billingAddress.street != '' ? data.billingAddress.street : 'NA',
        countryCode: data.billingAddress.country,
        city: data.billingAddress.city,
        postalCode: data.billingAddress.postalCode,
        stateOrProvince: data.billingAddress.stateOrProvince,
        firstName: bifurcatedName && bifurcatedName['firstName'],
        lastName: bifurcatedName && bifurcatedName['lastName'],
        emailAddress: inputFieldValues && (0, _commonUtils.trimEmail)(inputFieldValues['emailAddress']),
        phoneNumber: inputFieldValues && inputFieldValues['phoneNumber']
      } : bifurcatedName && {
        addressType: 'BILLING',
        firstName: bifurcatedName && bifurcatedName['firstName'],
        lastName: bifurcatedName && bifurcatedName['lastName'],
        emailAddress: inputFieldValues && (0, _commonUtils.trimEmail)(inputFieldValues['emailAddress']),
        phoneNumber: inputFieldValues && inputFieldValues['phoneNumber']
      };
    default:
      return undefined;
  }
};

/**
 * Prepares the payload for making a call to paymentPlus
 * for Authorization.
 *
 * @param data: Raw Adyen state data
 * @param referenceContainer: Containing the references of all the input fields
 * @param customData: custom data passed to the library
 * @param additionalData: The serialized data gathered post validation
 * @returns {Object}: Payload for Authorization
 */
exports.prepareBillingAddressForAuth = prepareBillingAddressForAuth;
var preparePayloadForAuthorization = function preparePayloadForAuthorization(data, stateRef, referenceContainer, customData, additionalData) {
  var _stateRef$current2;
  var inputFieldValues = getInputFieldValues(referenceContainer, additionalData);
  var currencyCode = customData.cart.currencyCode;
  var countryCode = customData.cart.countryCode;
  var caseId = customData.caseId;
  var paymentData = getPaymentData(_objectSpread(_objectSpread({}, data), {}, {
    countryCode: countryCode
  }));
  var browserInfo = data.browserInfo;
  var authorizeMetaData = additionalData['authorizeMetaData'] || {};
  var billingAddress = prepareBillingAddressForAuth(data, inputFieldValues, stateRef === null || stateRef === void 0 || (_stateRef$current2 = stateRef.current) === null || _stateRef$current2 === void 0 ? void 0 : _stateRef$current2.getAdyenBillingAddress());
  var userData = getUserData(customData, billingAddress, inputFieldValues);
  var sessionIds = stateRef.current.rmsId && {
    RMS: stateRef.current.rmsId
  };
  return _objectSpread({
    payment: paymentData,
    user: userData,
    browserInfo: browserInfo,
    billingAddress: billingAddress != '' ? billingAddress : undefined,
    cartAmount: stateRef.current.cartAmount,
    currencyCode: currencyCode,
    caseId: caseId,
    sessionIds: sessionIds
  }, authorizeMetaData);
};
exports.preparePayloadForAuthorization = preparePayloadForAuthorization;
var getUserData = function getUserData(customData, billingAddress, inputFieldValues) {
  var userData = customData && customData.userDetails && customData.userDetails.sameAsCardHolder ? _objectSpread(_objectSpread({}, inputFieldValues), {}, {
    firstName: billingAddress && billingAddress['firstName'],
    lastName: billingAddress && billingAddress['lastName']
  }) : !!inputFieldValues && !!inputFieldValues.firstName ? _objectSpread({}, inputFieldValues) : undefined;
  return userData;
};
exports.getUserData = getUserData;
var constructUserDetailsForPostValidate = function constructUserDetailsForPostValidate(data, stateRef, customData, referenceContainer, additionalData) {
  var _stateRef$current3;
  var inputFieldValues = getInputFieldValues(referenceContainer, additionalData);
  var billingAddress = prepareBillingAddressForAuth(data, inputFieldValues, stateRef === null || stateRef === void 0 || (_stateRef$current3 = stateRef.current) === null || _stateRef$current3 === void 0 ? void 0 : _stateRef$current3.getAdyenBillingAddress());
  return getUserData(customData, billingAddress, inputFieldValues);
};

/**
 * It serializes the data passed in post validation in required format
 *
 * @param data: Data provided post validation
 * @returns {Object}: Serialize data in required structure
 */
exports.constructUserDetailsForPostValidate = constructUserDetailsForPostValidate;
var additionalDataSerializers = function additionalDataSerializers(data) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, data['purchaserFirstName'] && {
    purchaserFirstName: data['purchaserFirstName']
  }), data['purchaserLastName'] && {
    purchaserLastName: data['purchaserLastName']
  }), data['purchaserEmail'] && {
    purchaserEmail: data['purchaserEmail']
  }), data['phone'] && {
    phone: data['phone']
  }), data['authorizeMetaData'] && {
    authorizeMetaData: data['authorizeMetaData']
  });
};
exports.additionalDataSerializers = additionalDataSerializers;